export const state = {
    navbarCollapse: false,
    navbarMobileOpen: false,
};

export const getters = {
    navbarCollapse: (states) => states.navbarCollapse,
    navbarMobileOpen: (states) => states.navbarMobileOpen,
};

export const mutations = {
    ['SAVE_MODE'](states, data) {
        states.navbarCollapse = data;
    },
    ['TOGGLE_MOBILE_MENU'](states) {
        states.navbarMobileOpen = !states.navbarMobileOpen;
    },
};

export const actions = {
    saveMode({ commit }, value) {
        commit('SAVE_MODE', value);
    },
    toggleMobileMenu({ commit }) {
        commit('TOGGLE_MOBILE_MENU');
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
